import { useUndo } from "../../Utils/undo";
import { EditOffSharp, ErrorSharp } from "@mui/icons-material";
import { useForceUpdate } from "@react-spring/shared";
import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import Fonts from "../middle.screen.parent.component/Fonts";
import Chrome from "react-color";
import Lottie from "lottie-web";
import AnimationPanel from "./AnimationPanel";
import { Tooltip } from "react-tippy";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { Button } from "@mui/material";
import ProjectContext from "../../context/ProjectContext";
import swal from "sweetalert";

const TextSettings = () => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    EditorZoom,
    setTTSData,
    editableObject,
    LayersData,
    setLayersData,
    setChangeCount,
    ChangeCount,
    seteditableObject,
    clone,
    isTTS,
    setIsTTS,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
  } = useContext(MyContext);
  const undo = useUndo();

  const { slides, setslides } = useContext(ProjectContext);

  const [showFontDiv, setshowFontDiv] = useState(false);

  var GoogleFonts = require("../../assets/GoogleFonts.json");

  const [values, setvalues] = useState(editableObject.editableItem);
  const [showColorPicker, setshowColorPicker] = useState(false);
  const [showMainPanel, setshowMainPanel] = useState(true);
  const [showAnimationPanel, setshowAnimationPanel] = useState(false);
  const [rangeValue, setrangeValue] = useState(values.opacity * 100);
  const [lineHeightRange, setlineHeightRange] = useState(values.LineHeight);
  const [letteSpacingRange, setletteSpacingRange] = useState(
    values.LetterSpacing
  );
  const [animationPanelType, setanimationPanelType] = useState("");
  useEffect(() => {
    setvalues(editableObject.editableItem);
    setshowColorPicker(false);
    setshowAnimationPanel(false);
    setshowMainPanel(true);
    if (editableObject.openAnimation) {
      setshowMainPanel(false);
      setshowAnimationPanel(true);
      setanimationPanelType(editableObject.animationPanelType);
    }
  }, [editableObject]);
  var currsize;

  const decrSize = async (Selectedfontsize) => {
    await StackStore();
    values.fontSize = parseInt(Selectedfontsize);
    currsize = parseInt(Selectedfontsize);
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].Editable = false;
        array[i].showDiv = false;
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + values.AnimationId);

        if (elm === null) {
          return;
        }

        // elm.style.fontSize = currsize + "px";
        let text = document.getElementById(
          "Text-" + values.AnimationId
        ).offsetParent;
        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };
  const incrSize = async (Selectedfontsize) => {
    await StackStore();
    //currsize = values.fontSize;
    values.fontSize = parseInt(Selectedfontsize);
    currsize = parseInt(Selectedfontsize);
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].Editable = false;
        array[i].showDiv = false;
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + values.AnimationId);
        if (elm === null) {
          return;
        }
        // elm.style.fontSize = currsize + "px";
        let text = document.getElementById("Text-" + values.AnimationId)
          .offsetParent.offsetParent;
        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
          array[i].originalWidth = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
          array[i].originalWidth = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].originalHeight = elm.offsetHeight;
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
          array[i].originalHeight = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  const generateFontSize = () => {
    var options = [];
    for (var i = 2; i < 150; i = i + 2) {
      if (
        i === Math.round(values.fontSize) ||
        i === Math.round(values.fontSize) + 1
      ) {
        options.push(<option selected>{i}</option>);
      } else {
        options.push(<option>{i}</option>);
      }
    }
    return options;
  };

  const updateFontSize = (e) => {
    // await StackStore();
    // const array = Array.from(LayersData);
    if (e.target.value > values.fontSize) {
      incrSize(e.target.value);
    } else {
      decrSize(e.target.value);
    }

    // for (let i = 0; i < array.length; i++) {
    //   if (array[i].key === values.key) {
    //     //Increasing font
    //     if (parseInt(e.target.value) > array[i].fontSize) {
    //       incrSize(e);
    //     }
    //     //decreasing font
    //     else {
    //       decrSize(e);
    //     }
    //   }
    // }
  };

  //Bold function
  const fontBold = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.fontWeight === "normal") {
          array[i].fontWeight = "bold";
        } else {
          array[i].fontWeight = "normal";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Underline Text function
  const TextUnderline = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.textDec === "none") {
          array[i].textDec = "underline";
        } else {
          array[i].textDec = "none";
        }
        break;
      }
    }

    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Font Italic function
  const FontItalic = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.Fontstyle === "normal") {
          array[i].Fontstyle = "italic";
        } else {
          array[i].Fontstyle = "normal";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Alignment function
  const Aligned = async (obj) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].Align = obj;
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Lock function
  const lockFun = async () => {
    undo("lockFun"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].lock = !array[i].lock;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
    //leftPanelHide
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //delete function
  const deleteFun = () => {
    undo("deleteFun"); // Ctrl+Z goes back to before this change
    // debugger;
    setIsTTS(false);
    var array = Array.from(LayersData);
    let changeArray = array.filter(function (value, index, arr) {
      if (value.key !== values.key) {
        return value;
      } else {
        if (value.type == "Props") {
          Lottie.destroy(value.AnimationId);
        } else if (value.type == "Character") {
          Lottie.destroy(value.AnimationId);
        }
      }
    });
    setLayersData(changeArray);
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Duplicate Element Function
  const Duplicate = (params) => {
    undo("Duplicate"); // Ctrl+Z goes back to before this change
    var typelength = 1;
    var checkKey = 0;
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === values.type) {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
      }
      if (LayersData[i].FurtherSetting === true) {
        LayersData[i].FurtherSetting = false;
      }
    }
    const array2 = JSON.parse(JSON.stringify(values));
    array2.key = checkKey + 1;
    if (array2.type === "text") {
      array2.TextId = values.TextId + "-" + typelength;
    }
    array2.x = array2.x + 10;
    array2.y = array2.y + 10;
    array2.Name = `${values.type}-${typelength}`;
    array2.AnimationId = values.AnimationId + "-" + typelength;
    array2.layerIndex = topIndex;
    array2.toolbar = false;
    array2.FurtherSetting = false;
    array2.Editable = true;
    setLayersData(LayersData.concat(array2));
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Opacity Function
  const changingOpacity = (value) => {
    undo("changingOpacity"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].opacity = value / 100;
        array[i].originalOpacity = value / 100;
        break;
      }
    }
    setLayersData(array);
    setrangeValue(Math.trunc(value));
  };

  //Lineheight Function
  const changeingLineHeight = (value) => {
    undo("changeingLineHeight"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].LineHeight = value;
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
    setlineHeightRange(value);
  };

  //Letter Spacing Function
  const changingLetterSpacing = (value) => {
    undo("changingLetterSpacing"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].LetterSpacing = value;
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
    setletteSpacingRange(value);
  };

  //Alignment to canvas function
  const alignCanvas = async (alignment) => {
    let elm = document.getElementById("Text-" + values.AnimationId);
    if (elm === null) {
      return;
    }
    await StackStore();

    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (alignment === "left") {
          array[i].x = 0;
          array[i].orignalX = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "right") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var xpostion =
            editor.clientWidth - (array[i].width * EditorZoom) / 100;
          array[i].x = (xpostion / EditorZoom) * 100;
          array[i].orignalX = xpostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "top") {
          array[i].y = 0;
          array[i].originalY = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "bottom") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            editor.clientHeight - (array[i].height * EditorZoom) / 100;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerV") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientHeight - (array[i].height * EditorZoom) / 100) / 2;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerH") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientWidth - (array[i].width * EditorZoom) / 100) / 2;
          array[i].x = (ypostion / EditorZoom) * 100;
          array[i].orignalX = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        }
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
    //Repeating this to update the dragger
    const array2 = Array.from(LayersData);
    for (let i = 0; i < array2.length; i++) {
      if (array2[i].key === values.key) {
        array2[i].Editable = true;
        array2[i].showDiv = true;
        break;
      }
    }
    setLayersData(array2);
  };

  //color picker functions
  const [Textcolor, setTextcolor] = useState(values.textColor);

  var ClrChangeStart = false;
  const colorChange = (e) => {
    if (ClrChangeStart === false) {
      ClrChangeStart = true;
      // props.setoverlayHide(true)
    }
    setTextcolor(e.rgb);
  };

  const colorChangeComplete = async (e) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].textColor = e.hex;
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
    ClrChangeStart = false;
    // setTimeout(function () { props.setoverlayHide(false) }, 200);
    //console.log("CompleteCall");
  };

  const ApplyWatermarkOnAllSlide = (item) => {
    var _slide = Array.from(slides);
    for (let i = 0; i < _slide.length; i++) {
      if (!_slide[i].LayerData.find((x) => x.subtype == "watermark"))
        _slide[i].LayerData = _slide[i].LayerData.concat(item);
    }
    setslides(_slide);
    swal("Excellent", "Watermark Settings Applied on All Slides", "success");
  };

  const RemoveWatermarkOnAllSlide = (item) => {
    undo("RemoveWatermarkOnAllSlide"); // Ctrl+Z goes back to before this change
    LayersData.splice(
      LayersData.indexOf(LayersData.find((x) => x.subtype == "watermark")),
      1
    );
    var _slide = Array.from(slides);
    for (let i = 0; i < _slide.length; i++) {
      var watermark = _slide[i].LayerData.find((x) => x.subtype == "watermark");
      if (watermark) {
        _slide[i].LayerData.splice(
          _slide[i].LayerData.indexOf(
            _slide[i].LayerData.find((x) => x.subtype == "watermark")
          ),
          1
        );
      }
    }
    setslides(_slide);
    setLayersData(LayersData);
    swal("Excellent", "Watermark Removed from All Slides", "success");
  };

  return (
    <div
    //   onClick={() => {
    //     if (showColorPicker) setshowColorPicker(false);
    //   }}
    >
      {showMainPanel && (
        <>
          <div className="d-flex topOptions">
            <div className="settingsTitle bolderFont">Edit Text</div>
            <div className="topRightOptions">
              <button
                onClick={() => {
                  setshowMainPanel(false);
                  setshowAnimationPanel(true);
                }}
                className="btn btn-small btn-Special mr-2"
              >
                Animate
              </button>
              <Tooltip
                title="Duplicate"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons grey" onClick={Duplicate}>
                  <span className="material-icons">content_copy</span>
                </div>
              </Tooltip>
              <Tooltip
                title="Delete"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons red" onClick={deleteFun}>
                  <span className="material-icons material-icons-outlined">
                    delete
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Lock"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons black" onClick={lockFun}>
                  <span className="material-icons material-icons-outlined">
                    lock
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="fontSizeAndFamily">
            <div
              className="fontSelectCustom"
              onClick={() => setshowFontDiv(true)}
            >
              <div className="labelWrapper">
                <label>{values.googleFontSetting.fontName}</label>
              </div>

              <div className="iconWrapper">
                <span className="material-icons smallIcon">expand_more</span>
              </div>
            </div>
            <div className="fontSizeDiv">
              <div className="selectIcon">
                <span className="material-icons smallIcon ">expand_more</span>
              </div>
              <div className="selectIcon2">
                <span className="material-icons smallIcon ">expand_less</span>
              </div>
              <input
                type="number"
                min="2"
                max="300"
                step="2"
                value={values.fontSize}
                onChange={(e) => updateFontSize(e)}
              />
              <div className="FontSizeDropdown"></div>
              {/* <select onChange={(e) => updateFontSize(e)}>
            {generateFontSize()}
          </select> */}
            </div>
          </div>
          {/* Here starts color picker */}
          <div className="moreOptions">
            <Tooltip
              title="Bold"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div
                onClick={fontBold}
                className={
                  values.fontWeight === "bold"
                    ? "toggleIconSettingsActive"
                    : "toggleIconSettings"
                }
              >
                <span className="material-icons smallIcon selectIcon">
                  format_bold
                </span>
              </div>
            </Tooltip>

            <Tooltip
              title="Underline"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div
                onClick={TextUnderline}
                className={
                  values.textDec === "underline"
                    ? "toggleIconSettingsActive"
                    : "toggleIconSettings"
                }
              >
                <span className="material-icons smallIcon selectIcon">
                  format_underlined
                </span>
              </div>
            </Tooltip>

            <Tooltip
              title="Italic"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div
                onClick={FontItalic}
                className={
                  values.Fontstyle === "italic"
                    ? "toggleIconSettingsActive"
                    : "toggleIconSettings"
                }
              >
                <span className="material-icons smallIcon selectIcon">
                  format_italic
                </span>
              </div>
            </Tooltip>

            <Tooltip
              title="Align Left"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div
                onClick={() => Aligned("left")}
                className={
                  values.Align === "left"
                    ? "toggleIconSettingsActive"
                    : "toggleIconSettings"
                }
              >
                <span className="material-icons smallIcon selectIcon">
                  format_align_left
                </span>
              </div>
            </Tooltip>

            <Tooltip
              title="Align Center"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div
                onClick={() => Aligned("center")}
                className={
                  values.Align === "center"
                    ? "toggleIconSettingsActive"
                    : "toggleIconSettings"
                }
              >
                <span className="material-icons smallIcon selectIcon">
                  format_align_center
                </span>
              </div>
            </Tooltip>

            <Tooltip
              title="Align Right"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div
                onClick={() => Aligned("right")}
                className={
                  values.Align === "right"
                    ? "toggleIconSettingsActive"
                    : "toggleIconSettings"
                }
              >
                <span className="material-icons smallIcon selectIcon">
                  format_align_right
                </span>
              </div>
            </Tooltip>
          </div>
          <div className="LabelWithSlider Alignments">
            <div className="settingsTitle mb-2">Align to Canvas</div>
            <div className="opacitySlider">
              <Tooltip
                title="Align Canvas Left"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("left")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_left
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas Right"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("right")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_right
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas Top"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("top")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_top
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Align Canvas bottom"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("bottom")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_bottom
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Verticle Center"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("centerV")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_vertical_center
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Horizontal Center"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div
                  onClick={() => alignCanvas("centerH")}
                  className={"toggleIconSettings"}
                >
                  <span className="material-icons smallIcon selectIcon">
                    align_horizontal_center
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="colorSettings">
            <div className="settingsTitle">Color</div>
            <Tooltip
              title="Change Text Color"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div className="colorPicker">
                <div
                  className="colorDisplay"
                  style={{ backgroundColor: values.textColor }}
                  onClick={() => setshowColorPicker(true)}
                ></div>
              </div>
            </Tooltip>
          </div>
          <div className="LabelWithSlider Transparency">
            <div className="settingsTitle">Transparency</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={100}
                  minValue={0}
                  value={rangeValue}
                  onChange={(value) => changingOpacity(value)}
                />
              </div>
              <div className="opacityValue">{Math.round(rangeValue)}</div>
            </div>
          </div>
          <div className="LabelWithSlider LineHeight">
            <div className="settingsTitle">Line Height</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={2}
                  minValue={1}
                  step={0.01}
                  value={lineHeightRange}
                  onChange={(value) => changeingLineHeight(value)}
                />
              </div>
              <div className="opacityValue">{lineHeightRange?.toFixed(2)}</div>
            </div>
          </div>
          <div className="LabelWithSlider LetterSpacing">
            <div className="settingsTitle">Letter Spacing</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={1}
                  minValue={-0.2}
                  step={0.1}
                  value={letteSpacingRange}
                  onChange={(value) => changingLetterSpacing(value)}
                />
              </div>
              <div className="opacityValue">
                {letteSpacingRange?.toFixed(1)}
              </div>
            </div>
          </div>
        </>
      )}

      {showAnimationPanel && (
        <AnimationPanel
          setshowMainPanel={setshowMainPanel}
          setshowAnimationPanel={setshowAnimationPanel}
          values={values}
          animationPanelType={animationPanelType}
        />
      )}

      {showFontDiv && (
        <div className="fontsDiv">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => setshowFontDiv(false)}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Change Font Type</div>
          </div>
          <div className="scrollerForFont">
            <div className="getFonts scrollbar style-1">
              {GoogleFonts.map((value, index) => {
                return (
                  <>
                    <Fonts
                      fontName={value.fontName}
                      fontFamily={value.fontFamily}
                      googleFontUrl={value.googleFontUrl}
                      layervalue={values}
                      rowIndex={index}/>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {showColorPicker && (
        <div className="colorDiv">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => setshowColorPicker(false)}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Change Text Color</div>
          </div>
          <Chrome
            color={Textcolor}
            onChange={colorChange}
            disableAlpha={true}
            onChangeComplete={colorChangeComplete}
            className="PickerSize"
          />
        </div>
      )}

      {values.subtype == "watermark" && (
        <>
          <div>
            <br />

            <Button
              style={{
                marginTop: "10px",
                marginLeft: "10px",
                background: "#296AFF",
                width: "90%",
              }}
              onClick={(e) => {
                ApplyWatermarkOnAllSlide(values);
              }}
              variant="contained"
              color="success"
            >
              Apply Watermark on All Slides
            </Button>
          </div>
        </>
      )}

      {values.subtype == "watermark" && (
        <>
          <div>
            <br />

            <Button
              style={{
                marginTop: "10px",
                marginLeft: "10px",
                background: "#296AFF",
                width: "90%",
              }}
              onClick={(e) => {
                RemoveWatermarkOnAllSlide(values);
              }}
              variant="contained"
              color="success"
            >
              Remove Watermark on All Slides
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
export default TextSettings;
